module.exports = __webpack_public_path__ + "img/t1-22.2c4f0f9d.png";